export const calcSumInOut = (arr, setPlayersInOutScore) => {
  let sum1In = 0;
  let sum1Out = 0;
  let sum2In = 0;
  let sum2Out = 0;
  let sum3In = 0;
  let sum3Out = 0;
  let sum4In = 0;
  let sum4Out = 0;

  for (let a = 0; a < 18; a++) {
    if (a < 9) {
      sum1In += arr[0][a].score;
      sum2In += arr[1][a].score;
      sum3In += arr[2][a].score;
      sum4In += arr[3][a].score;
    } else {
      sum1Out += arr[0][a].score;
      sum2Out += arr[1][a].score;
      sum3Out += arr[2][a].score;
      sum4Out += arr[3][a].score;
    }
  }

  setPlayersInOutScore({
    player1In: sum1In,
    player1Out: sum1Out,
    player2In: sum2In,
    player2Out: sum2Out,
    player3In: sum3In,
    player3Out: sum3Out,
    player4In: sum4In,
    player4Out: sum4Out,
  });
};
